/**
 * Ninox-Hash-URL-Parsing (F8, optionaler Weg 2).
 *
 * Ein direkter Auslesezugriff auf den Ninox-Tab ist cross-origin unmöglich —
 * der Melder kann stattdessen die Adresszeile kopieren und hier einfügen.
 * Format (beobachtet, bewusst tolerant geparst):
 *   …/#/teams/<teamId>/database/<dbId>/module/<tableId>/view/<viewId>/node/<recordId>/tab/<tabId>
 * Segmentnamen variieren je Ninox-Version (database/databases, module/table,
 * view/views, node/record) — daher Schlüssel-Wert-Paare aus dem Hash-Pfad lesen.
 */

export interface NinoxUrlTeile {
  teamId?: string
  databaseId?: string
  tabelleId?: string
  /** Sicht/View (F8: bestimmt die betroffene Ansicht der Tabelle) */
  viewId?: string
  recordId?: string
}

const SCHLUESSEL: Record<string, keyof NinoxUrlTeile> = {
  teams: "teamId",
  team: "teamId",
  database: "databaseId",
  databases: "databaseId",
  module: "tabelleId",
  table: "tabelleId",
  tables: "tabelleId",
  view: "viewId",
  views: "viewId",
  node: "recordId",
  record: "recordId",
  records: "recordId",
}

/** Parst eine Ninox-URL; liefert null, wenn nichts Verwertbares drinsteht. */
export function ninoxUrlParsen(eingabe: string): NinoxUrlTeile | null {
  const text = eingabe.trim()
  if (!text) return null

  let hash: string
  try {
    hash = new URL(text).hash
  } catch {
    // Auch nackte Hash-Routen („#/teams/…“ oder „/teams/…“) akzeptieren
    hash = text
  }
  const pfad = hash.replace(/^#?\/?/, "")
  const segmente = pfad.split("/").filter(Boolean)

  const teile: NinoxUrlTeile = {}
  for (let i = 0; i < segmente.length - 1; i++) {
    const ziel = SCHLUESSEL[segmente[i].toLowerCase()]
    if (ziel && !teile[ziel]) teile[ziel] = decodeURIComponent(segmente[i + 1])
  }
  return Object.keys(teile).length > 0 ? teile : null
}
